import { NewCheckbox } from '../../../../Components/PIM/common/NewCheckbox';

interface SelectionHeaderProps {
  isSelectAll?: boolean;
  onSelectAll?: () => void;
  /** Some rows selected but not all — renders the mixed-state dash, as the PIM table does. */
  isPartialSelection?: boolean;
  /** Locked while a bulk edit is open, so the selection cannot drift from the open rows. */
  disabled?: boolean;
}

/**
 * Select-all checkbox rendered in the selection column header. Toggles every row's
 * selection through the same state the card list uses (isSelectAll + selectedIds).
 */
function SelectionHeader(props: SelectionHeaderProps) {
  const { isSelectAll = false, isPartialSelection = false, onSelectAll, disabled = false } = props;
  return (
    <NewCheckbox
      size="sm"
      className="ptv-select-checkbox"
      aria-label="Select all"
      checked={isSelectAll}
      indeterminate={!isSelectAll && isPartialSelection}
      disabled={disabled}
      onChange={() => onSelectAll?.()}
    />
  );
}

export default SelectionHeader;
